export default {
    SAVE_REPO_DATA(state, payload) {
        state.repoData = payload
    }
}